// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-tab-container {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  width: "100%";
  border: 1px solid #dfe1e5;
}

.header-text-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 20px;
  padding-top: 10px;
}

.legend-style {
  border: 1px solid #dfe1e5 !important;
  border-radius: 4px !important;
  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;
  align-items: center;
  margin: 0;
  margin-bottom: 10px;
  padding: 5px;
}

.fieldset-style {
  border: 1px solid #dfe1e5 !important;
  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px !important;
}

.MuiFormControl-fullWidth .input-style {
  margin-bottom: 10px;
  margin-left: 0;
}

.MuiFormControl-fullWidth .input-select {
  margin-bottom: 10px !important;
  margin-left: 0;
}

.table-style {
  border: 1px solid #dfe1e5 !important;
  border-radius: 4px !important;
  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;
}

.margin2 {
  width: 2%;
}

.margin5 {
  margin-left: 10% !important;
}

.partIcon {
  width: 2em;
  height: 2em;
}

.MuiContainer-root {
  padding-left: 5px !important;
}

.MuiToolbar-regular {
  padding-left: 0 !important;
}

.MuiBox-root {
  padding: 10px !important;
  padding-top: 0px !important;
}

.MuiStack-root {
  padding: 5px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.MuiTypography-root {
  font-family: myfont !important;
}

.MuiButtonBase-root {
  font-family: myfont !important;
}

.MuiTablePagination-selectLabel {
  font-family: myfont !important;
}

.MuiInputBase-root {
  font-family: myfont !important;
}

.MuiTablePagination-displayedRows {
  font-family: myfont !important;
}

.MuiTableCell-root {
  font-family: myfont !important;
}

.MuiFormLabel-root {
  font-family: myfont !important;
}

.MuiFormControl-root {
  font-family: myfont !important;
}

.MuiButtonBase-root {
  font-family: myfont !important;
}

.MuiStack-root {
  padding-right: 0 !important;

  padding-left: 0 !important;
}

tr.MuiTableRow-root.Mui-selected {
  background: #828282 0 -3900px repeat-x !important;
}
.grid-wrapper{
  display: flex;
  justify-content: space-between;
  gap:5px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/home/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wDAAwD;EACxD,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;EACxD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;;EAE3B,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,WAAW;AACb","sourcesContent":[".header-tab-container {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: \"100%\";\n  border: 1px solid #dfe1e5;\n}\n\n.header-text-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding-right: 10px;\n  padding-left: 10px;\n  padding-bottom: 20px;\n  padding-top: 10px;\n}\n\n.legend-style {\n  border: 1px solid #dfe1e5 !important;\n  border-radius: 4px !important;\n  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;\n  align-items: center;\n  margin: 0;\n  margin-bottom: 10px;\n  padding: 5px;\n}\n\n.fieldset-style {\n  border: 1px solid #dfe1e5 !important;\n  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  padding: 10px !important;\n}\n\n.MuiFormControl-fullWidth .input-style {\n  margin-bottom: 10px;\n  margin-left: 0;\n}\n\n.MuiFormControl-fullWidth .input-select {\n  margin-bottom: 10px !important;\n  margin-left: 0;\n}\n\n.table-style {\n  border: 1px solid #dfe1e5 !important;\n  border-radius: 4px !important;\n  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa;\n}\n\n.margin2 {\n  width: 2%;\n}\n\n.margin5 {\n  margin-left: 10% !important;\n}\n\n.partIcon {\n  width: 2em;\n  height: 2em;\n}\n\n.MuiContainer-root {\n  padding-left: 5px !important;\n}\n\n.MuiToolbar-regular {\n  padding-left: 0 !important;\n}\n\n.MuiBox-root {\n  padding: 10px !important;\n  padding-top: 0px !important;\n}\n\n.MuiStack-root {\n  padding: 5px !important;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.MuiTypography-root {\n  font-family: myfont !important;\n}\n\n.MuiButtonBase-root {\n  font-family: myfont !important;\n}\n\n.MuiTablePagination-selectLabel {\n  font-family: myfont !important;\n}\n\n.MuiInputBase-root {\n  font-family: myfont !important;\n}\n\n.MuiTablePagination-displayedRows {\n  font-family: myfont !important;\n}\n\n.MuiTableCell-root {\n  font-family: myfont !important;\n}\n\n.MuiFormLabel-root {\n  font-family: myfont !important;\n}\n\n.MuiFormControl-root {\n  font-family: myfont !important;\n}\n\n.MuiButtonBase-root {\n  font-family: myfont !important;\n}\n\n.MuiStack-root {\n  padding-right: 0 !important;\n\n  padding-left: 0 !important;\n}\n\ntr.MuiTableRow-root.Mui-selected {\n  background: #828282 0 -3900px repeat-x !important;\n}\n.grid-wrapper{\n  display: flex;\n  justify-content: space-between;\n  gap:5px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
